export default function client(baseUrl) {
  const localTestBase = "http://localhost:5002/api/v1/";
  const localDevBase = "http://localhost:3001/api/v1/";
  const remoteBase = "https://glass-planner-api.herokuapp.com/api/v1/";
  baseUrl = baseUrl || remoteBase;
  if (window.Cypress) {
    baseUrl = localTestBase;
  }

  function simpleRequest({ url, token, method }) {
    console.log("token in request: ", token);
    let headers;
    if (token) {
      headers = { Authorization: "Bearer: " + token };
    } else {
      headers = {};
    }
    return new Promise((resolve, reject) => {
      fetch(baseUrl + url, {
        headers: headers,
        method: method,
      })
        .then((response) => {
          console.log("response", response);
          if (!response.ok) {
            reject(response);
          } else {
            return response.json();
          }
        })
        .then((data) => {
          if (!data) {
            return reject(data);
          }
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  function request({ url, method, json, token, id }) {
    console.log("request called", { url, method, json, token, id });
    switch (method) {
      case "POST":
        return post({ ...{ url, token }, body: json });
      case "GET":
        return get(url, token);
      case "PATCH":
        return patch({ ...{ url, token, id }, body: json });
      case "DELETE":
        return deleteReq({ ...{ url, id, token } });
    }
  }

  function post({ url, body, token }) {
    return bodyRequest({ url: url, body: body, token: token, method: "POST" });
  }

  function patch({ url, id, body, token }) {
    return bodyRequest({
      url: url,
      id: id,
      body: body,
      token: token,
      method: "PATCH",
    });
  }

  function deleteReq({ url, id, token }) {
    if (id) {
      url += "/" + id;
    }
    return simpleRequest({ method: "DELETE", ...{ url, token } });
  }

  function get(url, token) {
    return simpleRequest({ method: "GET", ...{ url, token } });
  }

  function bodyRequest({ url, id, body, token, method }) {
    let headers = { "Content-Type": "application/json" };
    if (token) {
      headers.Authorization = "Bearer: " + token;
    }
    const fullUrl = id ? baseUrl + url + "/" + id : baseUrl + url;
    console.log(
      "fullUrl",
      fullUrl,
      "baseUrl",
      baseUrl,
      "url",
      url,
      "both",
      baseUrl + url
    );
    return new Promise((resolve, reject) => {
      fetch(fullUrl, {
        method: method,
        headers: headers,
        body: JSON.stringify(body),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response);
          }
        })
        .then((data) => {
          if (!data) {
            reject(data);
          }
          resolve(data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  return { get, post, patch, deleteReq, request };
}
